<ng-container *transloco="let t; read: 'user'">
  <div class="flex flex-col w-96" id="completeEnrollmentDialog">
    <div class="flex flex-row justify-between border-b">
      <h1 class="text-[25px] font-bold">
        <span>
          {{ t('addNewChild.assign.title') }}
        </span>
      </h1>
      <i mat-button mat-dialog-close class="text-drdpblue-300 cursor-pointer uil uil-times-circle"></i>
    </div>

    <div mat-dialog-content>
      <form class="grid grid-cols-1 sm:grid-cols-2 gap-4 gap-x-10 mt-8 mb-6" [formGroup]="assignStudentForm">
        <div class="col-span-1 self-end">
          <drdp-select-state
            [initialStateId]="stateSearchId"
            (state)="handleDropdown($event, selectType.States)"
            [required]="true"
            >
          </drdp-select-state>
        </div>
        <div class="col-span-1 self-end">
          <drdp-select-agency
            [initialAgencyId]="agencyId.value"
            (agency)="handleDropdown($event, selectType.Agencies)"
            [stateId]="stateSearchId"
            [required]="true"
            >
          </drdp-select-agency>
        </div>
        <div class="col-span-1 self-end">
          <drdp-select-rating-period
            (ratingPeriod)="handleDropdown($event, selectType.RatingPeriods)"
            [initialRatingPeriodId]="ratingPeriodId.value"
            [agencyId]="agencyId.value"
            [required]="true"
            [omitFutureRps]="true"
            >
          </drdp-select-rating-period>
        </div>
        <div class="col-span-1 self-end">
          <drdp-select-site
            [initialSiteId]="siteId.value"
            (site)="handleDropdown($event, selectType.Sites)"
            [agencyId]="agencyId.value"
            [required]="true"
            >
          </drdp-select-site>
        </div>
        <div class="col-span-1 self-end">
          <drdp-select-class
            (classroom)="handleDropdown($event, selectType.Class)"
            [ratingPeriodId]="ratingPeriodId.value"
            [siteIds]="siteId.value"
            [multiSelect]="false"
            [required]="true"
            >
          </drdp-select-class>
        </div>
        <div class="self-end z-30">
          <drdp-date-picker [label]="t('addNewChild.assign.classroomEnrollmentDate')"
            [initialDate]="classEnrollmentDate?.value"
            labelClasses="pb-1"
            [isRequired]="true"
            (emitDate)="handleDate($event)">
          </drdp-date-picker>
          @if (classEnrollmentDate.hasError('dateRange')) {
            <mat-error class="text-xs">
              {{ t('addNewChild.assign.dateOutsideRatingPeriodError') }}
            </mat-error>
          }

          @if (classEnrollmentDate.hasError('agencyDate')) {
            <mat-error class="text-xs">
              {{ t('addNewChild.assign.dateBeforeAgencyEnrollmentError') }}
            </mat-error>
          }
        </div>

        @if (requireAgeGrade) {
          <div class="col-span-1 self-end">
            <drdp-select-age-grade [initialageGradeId]="ageGroupInstrument2025Id.value"
              [stateId]="stateSearchId" [label]="t('addNewChild.assign.ageGroupInstrument')"
              [multiSelect]="false"
              [required]="true"
              [isPilot]="true"
              [schoolYearId]="selectedSchoolYearId"
              [tooltip]="ageGradeIconInfo"
              (ageGrade)="handleDropdown($event, selectType.AgeInstrument)">
            </drdp-select-age-grade>
          </div>
        }
      </form>
      <div>
        <drdp-rating-periods [agencyId]="agencyId.value"></drdp-rating-periods>
      </div>
      <hr>
        <div class="mt-10 mb-2 flex justify-end">
          <drdp-btn class="pr-4" color="cancel" mat-dialog-close type="button">
            {{ t('addNewChild.common.cancel') }}
          </drdp-btn>
          <drdp-btn type="submit" (click)="onSubmit()" [disabled]="!assignStudentForm.valid" cdkFocusInitial>
            {{ t('addNewChild.common.saveAndEnroll') }}
          </drdp-btn>
        </div>
      </div>
    </div>
</ng-container>
